// @flow
import React, { Fragment, type Node } from 'react';
import { isEmpty } from 'ramda';

import type { ComplexItem } from 'app/common/components/Cafeteria/dataTypes/orderRequestSales/OrderRequestSale.types';

import Portion from './parts/Portion';
import styles from './CellSellTitle.module.scss';;


type Props = {
  title: ?string,
  items: ?Array<ComplexItem>
}

const CellSellTitle = ({ title, items }: Props): Node => {
  const hasItems = items && !isEmpty(items);
  return (
    <Fragment>
      <div>{title || '—'}</div>
      {hasItems
        && <ol className={styles.items}>
          {items && items.map(({ id, title: name, portion }, index) => (
            <li key={id} className={styles.item}>
              <span>{`${index + 1}.`}</span>
              <span>{name}</span>
              <span>
                <Portion portion={portion} />
              </span>
            </li>
          ))}
        </ol>}
    </Fragment>
  );
};

export default CellSellTitle;
